import api from "../services/api"

const refreshToken = (dispatch) => {
  api.get("/refresh-user").then(res => {
    localStorage.setItem("mpt-Token", res.token)
    dispatch({ type: 'SIGN_IN', user: res.user, token: res.token })
  })
}

export default refreshToken;